<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">客户转化率·数据表格</h5>
        </a-col>
      </a-row>
    </template>
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <!-- <a-form-item label="名称">
            <a-input v-model="dataForm.role_name" placeholder="名称" />
          </a-form-item> -->
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增转化数据</a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="exportHandle" type="primary" :loading="dataListLoading || exportLoading">导出</a-button>
          </a-form-item>
        </a-form>

        <a-table :scroll="{ x: 1500 }" :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
          :loading="dataListLoading">
          <template slot="department.department_name" slot-scope="department_name">
            <a-tag>{{ department_name }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.id)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      exportFileName: "客户转化率导出",
      mixinViewModuleOptions: {
        getDataListURL: "/admin/domain/page",
        deleteURL: "/admin/domain/delete",
        exportURL: "/admin/domain/export",
      },
      dataForm: {
      },
      columns: [
        {
          title: "日期",
          dataIndex: "day",
          width: 150,
          customRender: (text) => text.substr(0, 11),
        },
        {
          title: "转化率",
          dataIndex: "conversionrate",
          width: 120,
          customRender: (text) => (text ?? 0) + '%',
        },
        {
          title: "入私域人数",
          dataIndex: "domaincount",
          width: 130,
          customRender: (text) => (text ?? 0) + '人',
        },
        {
          title: "三亚咨询数量",
          dataIndex: "sanyaallcount",
          width: 130
        },
        {
          title: "三亚成交数量",
          dataIndex: "sanyacount",
          width: 130
        },
        {
          title: "澳门咨询数量",
          dataIndex: "aomenallcount",
          width: 130
        },
        {
          title: "澳门成交数量",
          dataIndex: "aomencount",
          width: 130
        },
        {
          title: "创建时间",
          dataIndex: "createtime",
          width: 200
        },
        {
          title: "修改时间",
          dataIndex: "updatetime",
          width: 200
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  methods: {},
};
</script>